import React from 'react'
import { useReport } from './ReportProvider'
import { EmbeddedReport } from './EmbeddedReport'
import { DNABox } from '@alucio/lux-ui'
import ExportCsvReport from './ExportCsvReport'
const WrapperReport: React.FC = () => {
  const { selectedReport } = useReport()

  const isCsvExportReport = selectedReport?.dashboardId === 'export_meeting_report'

  return (
    <DNABox fill>
      {isCsvExportReport && <ExportCsvReport />}
      <DNABox fill style={{ display: isCsvExportReport ? 'none' : 'flex' }}>
        <EmbeddedReport />
      </DNABox>
    </DNABox>
  )
}

export default WrapperReport
